import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewTipoValor = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'tipo_valor',
        name: 'Tipo valor',
        component: ViewTipoValor,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
